/**
 * 自由布局的标签页切换
 */
const variableRE = /\(\(((?:.|\r?\n)+?)\)\)/g

export default {
  watch:{
    "options.activeIndex"(n, o) {
      let _this = this
      // 判断是否存在交互事件插件，此插件用于切换标签页重新执行交互事件
      let eventArr = this.$event.eventBus.stage
      for (let key in eventArr) {
        let event1 = eventArr[key].events.dataEvents.appointDataChange
        if (event1.length > 0) {
          event1.forEach((event, index) =>{
            if(event.ids && event.ids.rect_id === this.myid.rect_id){
              //  自由布局是响应组件
              const execVariableKeys = Object.keys(event.variableTag).filter(k =>
                  event.variableTag[k].hasOwnProperty("triggerType")
              )
              let berforeE = event.lifeCycle.beforeTrigger
              if (berforeE.length > 0) {
                berforeE.forEach(item => {
                  if (item.pluginName === "immediateTrue") {
                    // _this.$event.trigger(event, null)
                    setTimeout(() => {
                      _this.$event.trigger(event, null)
                    }, 100)
                  }
                })
              } else if (_this.checkWatcher(event, execVariableKeys)) {
                setTimeout(() => {
                  _this.$event.trigger(event, null)
                }, 10)
              }
            }
          })
        }
      }
    }
  },
  methods: {
    /**
     * 检查所监听的值是否符合预设
     * @param {object} event 当前组件的事件描述
     * @param {object} execVariableKeys 当前事件所用监听的值
     * @returns {boolean} 置否符合预设的条件
     */
    checkWatcher(event, execVariableKeys) {
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], event.from)
      const { from, path, variableTag } = event
      let status = ""
      execVariableKeys.forEach((k, index) => {
        const tag = variableTag[k]
        let { matchStr, mode, matchType, path, triggerType } = tag
        matchType = matchType || ""
        matchType = matchType.replaceAll("&lt;", "<").replaceAll("&gt;", ">")
        //执行器条件,会出现以下需要校验的场: 变量 > 1 && 变量2 <50 || 变量3 >100
        //分别获取每一个变量的执行结果,例如 变量1 > 1 的执行结果,然后再进行 且/或 的判定
        if (triggerType === "exec") {
          const tarVariableVal = this.hasProperty(rectAttr.options, path)
          const variables = matchStr.match(variableRE)?.map(it => it.slice(2, -2))
          if (variables?.length) {
            //处理匹配字符串中的变量值
            variables.forEach(variableName => {
              matchStr = matchStr.replaceAll(
                  `((${variableName}))`,
                  this.hasProperty(rectAttr.options, variableTag[variableName].path)
              )
            })
          }
          const type = Object.prototype.toString.call(tarVariableVal).slice(8, -1)
          //根据目标变量的值,进行预设的多条件满足的判断
          status += eval(`${this.fixType(tarVariableVal, type)}${matchType}${this.fixType(matchStr, type)}`)
        }
        if (index !== execVariableKeys.length - 1) {
          status += mode
        }
      })
      return eval(status)
    },
    fixType(val, type) {
      switch (type) {
        case "String":
          return `"${val}"`
        case "Boolean":
          return Boolean(val)
        case "Number":
          return Number(val)
        case "Null":
          return null
        case "undefined":
          return undefined
        case "Array":
          return Array.from(val)
        case "Object":
          return Object(val)
        default:
          return val
      }
    }
  }
}
